import React from "react";
import { Pill, Reveal } from "./Reveal";
import { PillButton } from "./Kit";
import ShaderBackground from "./ShaderBackground";
import Radar from "./Radar";

export default function ScorecardTeaser() {
  return (
    <section className="px-3 pt-3 sm:px-5 sm:pt-5" data-testid="scorecard-teaser">
      <div className="relative mx-auto max-w-[1400px] overflow-hidden rounded-[28px] bg-black p-7 text-white sm:p-12">
        <ShaderBackground dark strength={0.2} lines={12} fadeLeft={0} />
        <div className="relative z-10 grid items-center gap-8 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <Pill white>Free · 60 seconds</Pill>
            <h2 className="nm-title mt-6 max-w-[760px] text-[34px] leading-[1.02] sm:text-[60px]">
              Is your firm ready to let ChatGPT or Claude do real work?
            </h2>
            <p className="mt-5 max-w-[520px] text-[18px] leading-[1.3] text-white/65">
              Seven questions give you a score out of 21, the gaps that matter and
              a plan for your next 90 days. No email needed.
            </p>
            <div className="mt-8">
              <PillButton to="/scorecard" variant="inverse" size="lg" data-testid="teaser-cta">
                Take the scorecard
              </PillButton>
            </div>
          </Reveal>
          <Reveal className="lg:col-span-4 lg:col-start-9" delay={150}>
            <Radar demo labels={false} className="mx-auto w-full max-w-[320px] text-white" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
